import { legacyWorkScheduleHistory } from '../../mock/legacyWorkScheduleHistory'
import './LegacyWorkScheduleHistory.css'

export function LegacyWorkScheduleHistory() {
  const scheduleId = new URLSearchParams(window.location.search).get('schedule_id') ?? ''
  const rows = scheduleId.startsWith('mock-') ? legacyWorkScheduleHistory : []

  return <main className="main_wrapper g_main_content legacy-s03-history-main">
    <div className="g_title">스케줄 변경 내역</div>
    <div className="g_card">
      <div className="g_list_wrap">
        <table className="g_list" id="l_work_schedule_history_list">
          <thead>
            <tr><th>일자</th><th>내용</th><th>변경직원</th></tr>
          </thead>
          <tbody>
            {rows.length > 0 ? rows.map((row) => <tr key={row.id}>
              <td className="l_history_date">{row.date}</td>
              <td className="l_history_type">{row.workingTypeName}</td>
              <td className="l_history_staff">{row.staffName}</td>
            </tr>) : <tr><td className="l_empty_data_row" colSpan={3}>변경내역을 확인할 수 없습니다.</td></tr>}
          </tbody>
        </table>
      </div>
      <div className="g_btn_wrap">
        <button className="g_btn close" type="button" id="l_work_schedule_history_popup_close" onClick={() => window.close()}>닫기</button>
      </div>
    </div>
  </main>
}
